export enum IntegrationStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  SUPPORTED = "SUPPORTED",
}
